const maxLength = 2000;

export const getUserStatistics = (token = {}) => {
  const { tongdun = '' } = token;
  return [
    {
      key: 'tongdun_source',
      value: 'dqshweb',
    },
    {
      key: 'tongdun_blackbox',
      value: tongdun.slice(0, maxLength),
    },
    {
      key: 'tongdun_tokenid',
      value: 'ABC',
    },
    {
      key: 'tongdun_appname',
      value: 'HomeCredit_vn_web',
    },
  ];
};
